/** @typedef {{ kind: 'channel', channel: object, epgIndex: number }} EpgChannelRow */
/** @typedef {{ kind: 'rowAd', row: object }} EpgRowAdRow */
/** @typedef {EpgChannelRow | EpgRowAdRow} EpgDisplayRow */

/**
 * Insere o row ad na posição `row.position` em relação às linhas de canal (com schedules).
 * `position` 0 = antes do 1.º canal; 1 = após o 1.º; 2 = após o 2.º; etc.
 * Se `position` for maior que o número de canais, o banner fica no fim.
 *
 * @param {object[]} channels
 * @param {object | null} rowAdModel
 * @returns {EpgDisplayRow[]}
 */
export function buildEpgDisplayRows(channels, rowAdModel) {
  /** @type {EpgDisplayRow[]} */
  const rows = [];
  let scheduleIndex = 0;
  let rowAdInserted = false;

  const posRaw = rowAdModel && rowAdModel.position != null ? Number(rowAdModel.position) : 1;
  const pos = Number.isFinite(posRaw) && posRaw >= 0 ? posRaw : 1;

  if (rowAdModel && pos === 0) {
    rows.push({ kind: 'rowAd', row: rowAdModel });
    rowAdInserted = true;
  }

  for (const channel of channels) {
    if (!channel.schedules) {
      // eslint-disable-next-line no-continue
      continue;
    }

    rows.push({ kind: 'channel', channel, epgIndex: scheduleIndex });
    scheduleIndex += 1;

    if (!rowAdInserted && rowAdModel && scheduleIndex === pos) {
      rows.push({ kind: 'rowAd', row: rowAdModel });
      rowAdInserted = true;
    }
  }

  if (!rowAdInserted && rowAdModel) {
    rows.push({ kind: 'rowAd', row: rowAdModel });
  }

  return rows;
}
